import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EncryptedBoxViewModelType from '@/ViewModels/Controls/EncryptedBoxViewModel';
import LabelType from '@/Controls/Label';
import ImageType from '@/Controls/Image';

export default class EncryptedBox extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private jQueryControl: JQuery;
    private label: LabelType;
    private image: ImageType;

    public constructor(private viewModel: EncryptedBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>').append('<div class="pattern">');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'encryptedbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible
        });

        if (this.viewModel.image != null) {
            this.image = new this.Image(this.viewModel.image);
            let tuple = this.image.getTuple();

            this.jQueryControl.append(tuple.control);
        }

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            this.jQueryControl.append(tuple.control);
        }
    }
}

ComponentManager.setControl('EncryptedBox', EncryptedBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');